
module.exports = {"attributes":{"width":"13","height":"14","version":"1.1","xmlns":"http://www.w3.org/2000/svg"},"content":"<g stroke=\"#000\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M11.5 7.5V13H.5V2H6M7.5 1h5v5\"/><path d=\"M12.2695 1.2305L7.5 6\" stroke-linecap=\"square\"/></g>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
